$(function(){
    /* === Scrollable header === */
    var position = $(window).scrollTop(); 

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if((scroll > position) && (scroll > 0)) {
            $('.header--scroll').addClass('header--scroll--hide');  
        }
        // else if ((position < 60) && (position > 0)) {
        //     $('.header--scroll').removeClass('header--scroll--hide');
        //     $('.header--scroll').css('background', 'purple');
        // }
        else {
            $('.header--scroll').removeClass('header--scroll--hide');
        }
        position = scroll;
    });
});


// $(function(){
//     /* === Scrollable header === */
//     var position = $(window).scrollTop(); 

//     $(window).scroll(function() {
//         var scroll = $(window).scrollTop();

//         if(scroll > position) {
//             $('header').addClass('header--small');
            
//         } else {
//             $('header').removeClass('header--small');
//         }

//         // if(scroll > position) {
//         //     $('.header--scroll').removeClass('header--scroll--show');
            
//         // } else {
//         //     $('.header--scroll').addClass('header--scroll--show');
//         // }
//         position = scroll;

//         // Hide at top
//         if ($(document).scrollTop() < 130) {
//             $('header').removeClass('header--small');
//         }
//     });

// })